// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1__p0","cls2":"Unibrow-cls2_VdZ Unibrow-cls1__p0"};